import { render, staticRenderFns } from "./levelTable.vue?vue&type=template&id=f0fc19e6"
import script from "./levelTable.vue?vue&type=script&lang=js"
export * from "./levelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports